module.exports = __webpack_public_path__ + "static/media/success.b3fd8c7f.png";